import type { VariantProps } from "tailwind-variants";

import { Badge2 } from "@/ui2/atoms/Badge";
import type { badgeStyles } from "@/ui2/atoms/Badge";
import { cn } from "@/lib/helpers/cn";
import type { PatientAcuityScore } from "@/core/types";

type Variant = VariantProps<typeof badgeStyles>["variant"];

const ACUITY_INDEX_TO_BADGE: Record<PatientAcuityScore, { label: string; variant: Variant }> = {
  1: {
    label: "Mild",
    variant: "success",
  },
  2: {
    label: "Moderate",
    variant: "warning",
  },
  3: {
    label: "Intense",
    variant: "unknown",
  },
  4: {
    label: "Severe",
    variant: "error",
  },
} as const;

type AcuityScoreBadgeProps = {
  acuityIndex: PatientAcuityScore;
  className?: string;
};

export function AcuityScoreBadge({ acuityIndex, className }: AcuityScoreBadgeProps) {
  const { label, variant } = ACUITY_INDEX_TO_BADGE[acuityIndex] || {};

  return (
    <Badge2
      className={cn("tw:normal-case", className)}
      size="md"
      variant={variant}
    >{`${acuityIndex} ${label}`}</Badge2>
  );
}
